module.exports = __webpack_public_path__ + "img/login_card2.585dcd2b.png";